<template>
	<div class="content-wapper">
		<el-row class="navigation">
			<el-col align="left">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
					<el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
					<el-breadcrumb-item :to="{ path: '/main/zscqzhfw/fwlmjj' }">知识产权综合服务</el-breadcrumb-item>
					<el-breadcrumb-item>知识产权服务联盟</el-breadcrumb-item>
				</el-breadcrumb>
			</el-col>
		</el-row>
		<el-row class="bottom-content">
			<el-col :span="6" class="left-col">
				<el-row>
					<img src="@/assets/images/zscqfwlm/1.png" style="width: 100%;" />
				</el-row>
				<el-row style="height: 3.0625rem;line-height: 3.0625rem;cursor: pointer;">
					<el-link :underline="false" style="float: left;font-size: 0.8125rem;" @click="fwlmFun">服务联盟简介</el-link>
					<i class="el-icon-arrow-right"
						style="float: right; margin-right: 0.625rem;line-height: 3.0625rem;"></i>
				</el-row>
				<el-row>
					<el-collapse v-model="activeName" accordion>
						<el-collapse-item title="服务机构（按机构名称首字母排序）" name="1">
							<el-row :gutter="50">
								<el-col :span="12" v-for="(item,index) in fwjgOptions" :key="index" style="margin-bottom: 0.625rem;cursor: pointer;">
									<span @click="fwjgFun(item.recid,index)" 
									:class="fwjgActiveClass == index ? 'fwjg-active':''">{{item.name}}</span>
								</el-col>
							</el-row>
						</el-collapse-item>
						<el-collapse-item title="知识产权专家（按专家姓氏首字母排序）" name="2">
							<el-row :gutter="30" >
								<el-col :span="8" v-for="(item,index) in zscqzjOptions" :key="index" style="margin-bottom: 0.625rem;cursor: pointer;">
									<span @click="zscqzjFun(item.deptCode,index)"
									:class="zscqzjActiveClass == index ? 'zscqzj-active':''">{{item.shortName}}</span>
								</el-col>
							</el-row>
						</el-collapse-item>
					</el-collapse>
				</el-row>
			</el-col>
			<el-col :span="18" class="right-col">
				<el-row>
					<span class="title">{{title}}</span>
					<el-divider></el-divider>
				</el-row>
				<el-row class="fwlm" v-show="fwlm_boolean">
					<el-col :span="24">
						威海市知识产权服务联盟遵循“自愿、平等、互利、合作”的原则，由威海市知识产权事业发展中心牵头，联合威海市知识产权代理机构、律师协会、知识产权评估与鉴定机构、金融机构、知识产权推介机构、科研院所和高校等与知识产权创造、运用、保护、管理关系密切的群体组成。服务联盟以“立足威海、辐射山东、服务全国”为目标，以 “服务公众、服务企业、服务社会、服务政府”为宗旨，形成资源共享、优势互补的知识产权服务共同体。服务联盟主要为企事业单位、行业协会、政府相关部门等提供专利咨询、专利检索、统计分析、侵权分析、重大项目知识产权审查论证、知识产权专利数据库建设、知识产权战略研究与预警分析、知识产权专家会诊、知识产权评估、知识产权转让交易、知识产权项目融资、知识产权人才培养等 “全方位、一站式、优质高效”的知识产权服务。
					</el-col>
				</el-row>
				<el-row class="fwjg" v-show="fwjg_boolean">
<!--					<el-table v-loading="fwjgLoading" :data="fwjgList" :show-header="false" tooltip-effect="light">
					    <el-table-column label="内容" align="left" class-name="small-padding fixed-width">
					        <template slot-scope="scope">-->
								<el-row :gutter="20">
									<template v-for="(item,index) in fwjgList">
										<el-col :span="8"  class="col-gap">
											<el-card class="box-card">
												<div slot="header" class="box-card-title" :title="item.name">{{item.name.length>18?item.name.substr(0,17)+'...':item.name}}</div>
												<div class="box-card-content">
													<div class="box-card-content-dom">
														<img  :src="mypng"/>
														&nbsp;&nbsp;<span>联系人&nbsp;&nbsp;:</span>
														<el-tag size="mini" v-if="!isLoginState" style="margin-left: 0.5rem">登录后查看</el-tag>
														<span v-else style="margin-left: 0.5rem">{{item.llr}}</span>
													</div>
													<div class="box-card-content-dom">
														<img  :src="telpng"/>
														&nbsp;&nbsp;<span>联系电话&nbsp;&nbsp;:</span>
														<el-tag size="mini" v-if="!isLoginState" style="margin-left: 0.5rem">登录后查看</el-tag>
														<span v-else style="margin-left: 0.5rem">{{item.llrtel}}</span>
													</div>
													<div class="synopsis-div">
														<el-tooltip placement="top" effect="light">
															<template slot="content">
																<p style="max-width:500px;line-height: 150%;">{{item.synopsis}}</p>
															</template>
														  <div class="synopsis" @click="fwjgOpenWebUrl(item.website)">简介</div>
														</el-tooltip>
													</div>
												</div>
											</el-card>
										</el-col>
									</template>
								</el-row>
<!--					        </template>
					    </el-table-column>
					</el-table>-->
					<pagination
						v-show="fwjgTotal>0"
						:total="fwjgTotal"
            :page-sizes="[12, 24, 48, 96]"
						:page.sync="fwjgQueryParams.pageNum"
						:limit.sync="fwjgQueryParams.pageSize"
						@pagination="getFwjgList"
					/>
				</el-row>
				<el-row class="zscqzj" v-show="zscqzj_boolean">
					<el-table v-loading="loading" :data="dataList" :header-cell-style="{background:'#f5f5f5f5',color:'#606266'}">
						<el-table-column label="姓名" align="center" prop="name"  :show-overflow-tooltip="true" width="110">
							<template slot-scope="scope">
								<span v-if="!isLoginState"><el-tag>登录后查看</el-tag></span>
								<span v-else>{{scope.row.name}}</span>
							</template>
						</el-table-column>
						<el-table-column label="性别" align="center" prop="sex" :show-overflow-tooltip="true" width="100">
							<template slot-scope="scope">
								<span>{{selectDictLabel(sexOptions,scope.row.sex)}}</span>
							</template>
						</el-table-column>
						<el-table-column label="学位" align="center" prop="higDegree" :show-overflow-tooltip="true" width="100"/>
						<el-table-column label="联系方式" align="center" prop="tel" :show-overflow-tooltip="true" width="150">
							<template slot-scope="scope">
								<span v-if="!isLoginState"><el-tag>登录后查看</el-tag></span>
								<span v-else>{{scope.row.tel}}</span>
							</template>
						</el-table-column>
						<el-table-column label="研究方向" align="center" prop="researchDirection" :show-overflow-tooltip="true"/>
						<el-table-column label="工作单位" align="center" prop="workUnit" :show-overflow-tooltip="true"/>
					</el-table>
					<pagination
						v-show="total>0"
						:total="total"
						:page.sync="queryParams.pageNum"
						:limit.sync="queryParams.pageSize"
						@pagination="getList"
					/>
				</el-row>
			</el-col>
		
		</el-row>
	</div>
</template>

<script>
	import {listZjxx} from '@/api/zscq/zjxx'
	import {listFwjglx} from '@/api/fwjg/fwjglx'
	import {listFwjg} from '@/api/fwjg/fwjg'
	import { getListDept } from "@/api/system/dept"
	import {updatePvNum} from "@/api/itempv/pv"
	export default {
		name: "fwlmjj",
		data() {
			return {
				activeName: '0',
				title:'服务联盟简介',
				fwlm_boolean:true,
				fwjg_boolean:false,
				zscqzj_boolean:false,
				loading: true,
				// 总条数
				total: 0,
				//table列表数据
				dataList: [],
				// 查询参数
				queryParams: {
					pageNum: 1,
					pageSize: 10,
					name:undefined,
					region:undefined
				},
				fwjgOptions:[],
				zscqzjOptions:[],
				fwjgActiveClass:-1,
				zscqzjActiveClass:-1,
				fwjgList:[],
				fwjgLoading:true,
				fwjgTotal:0,
				fwjgQueryParams: {
					pageNum: 1,
					pageSize: 12,
					type:undefined
				},
				deptQueryParams:{
					deptLevel:'3',
					deptType:'1'
				},
				sexOptions:[],
				//手机号等联系方式仅登录用户可见
				isLoginState:false,
				mypng:require('@/assets/images/fwlm/my.png'),
				telpng:require('@/assets/images/fwlm/tel.png')
			}
		},
		created() {
			let ssessionLoginUser = JSON.parse(localStorage.getItem('ssessionLoginUser'));
			this.isLoginState = ssessionLoginUser != null && ssessionLoginUser.islogin;
			this.getDicts("sys_user_sex").then(response => {
			    this.sexOptions = response.data;
			});
			this.getdeptlist();
			const en = JSON.parse(localStorage.getItem('IndexSearchContent'));
			this.queryParams.name = en;
			if (this.queryParams.name != undefined) {
				this.getList();
				this.fwlm_boolean = false;
				this.fwjg_boolean = false;
				this.zscqzj_boolean = true;
			}
			this.getFwjgList();
			this.getfwjglxlist();
		},
		methods: {
			getdeptlist(){
				getListDept(this.deptQueryParams).then(res => {
					this.zscqzjOptions = res.data;
				})
			},
			getfwjglxlist(){
				listFwjglx({}).then(res => {
					this.fwjgOptions = res.rows;
				})
			},
			toPage(url) {
				this.$router.push({
					path: url,
				});
				this.$store.commit('SET_MAININDEX', url);
			},
			fwlmFun(){
				this.title = "服务联盟简介";
				this.fwlm_boolean = true;
				this.fwjg_boolean = false;
				this.zscqzj_boolean = false;
				this.activeName = 0;
			},
			fwjgFun(recid,index){
				this.title = "服务机构";
				this.fwjg_boolean = true;
				this.fwlm_boolean = false;
				this.zscqzj_boolean = false;
				this.fwjgActiveClass = index;
				this.fwjgQueryParams.type = recid;
				this.getFwjgList();
				updatePvNum("zscq_zscqfwlm_fwjg").then(response => {
						//点击服务联盟机构
				});
			},
			zscqzjFun(deptCode,index){
				this.title = "知识产权专家";
				this.zscqzj_boolean = true;
				this.fwjg_boolean = false;
				this.fwlm_boolean = false;
				this.zscqzjActiveClass = index;
				this.queryParams.region = deptCode;
				this.getList();
				updatePvNum("zscq_zscqfwlm_zscqzj").then(response => {
					//点击服务联盟机构-专家
				});
			},
			getList(){
				this.dataList=[];
				this.loading = true;
				listZjxx(this.queryParams).then(response => {
				  this.dataList = response.rows;
				  this.total = response.total;
				  this.loading = false;
				});
				localStorage.removeItem("IndexSearchContent");
			},
			getFwjgList(){
				this.fwjgList=[];
				this.fwjgLoading = true;
				listFwjg(this.fwjgQueryParams).then(response => {
				  this.fwjgList = response.rows;
				  this.fwjgTotal = response.total;
				  this.fwjgLoading = false;
				});
			},
			fwjgOpenWebUrl(weburl){
				if(weburl != null && weburl !='' && weburl != undefined){
				this.utils.windowOpen(weburl)
				}
			}
		}
	}
</script>

<style scoped="scoped">
	.content-wapper {
		padding: 10px;
	}

	.navigation{
		padding:20px 15px;
		line-height: 20px;
		height: 60px;
		background-color: #F5F5F5;
		margin-bottom: 15px;
	}

	.bottom-content {
		margin-top: 0.9375rem;
		background-color: #F5F5F5;
	}

	.link-div {
		display: flex;
		flex-wrap: nowrap;
		justify-content: space-around;
	}

	.title {
		font-size: 1.125rem;
		color: #738ce1;
		font-weight: bold;
	}

	.left-col {
		padding: 0.625rem;
	}

	.right-col {
		margin-top: 0.625rem;
		padding: 0.625rem;
		/* 边框 */
		border: 0.0625rem solid #d7dae2;
		/* 阴影 */
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	}

	.right-col .el-row {
		text-align: left;
	}

	.right-col .fwlm {
		padding: 1rem 0.9375rem;
		font-size: 0.9375rem;
		line-height: 1.6625rem;
		text-indent: 2em;
		padding-bottom: 12rem;
	}
	.fwjg .fwjg-title{
		font-size: 1rem;
		font-weight: 700;
		cursor: pointer;
	}

  .col-gap{
    margin-bottom: 20px; /* 下边距 */
  }


	.el-icon-menu{
		margin-right: 0.625rem;
	}
	.fwjg .fwjg-content{
		margin: 0.5rem 0;
		padding: 0.9375rem;
		background-color: #F2F2F2;
		font-size: 0.75rem;
		text-indent: 2em;
		letter-spacing:2px;
	}
	.fwjg-div{
		border-bottom: 0.0625rem dashed #d7dae2;
		margin-bottom: 0.9375rem;
	}
	.fwjg-active{
		color: #ffaa00;
	}
	.zscqzj-active{
		color: #ffaa00;
	}
	.box-card-content-dom{
		display: flex;
		align-items: center;
		justify-content:flex-start;
	}
	.synopsis-div{
		margin-top: 1rem;
		border: 0.0625rem solid #d7dae2;
		border-radius: 0.1875rem;
	}
	.synopsis{
		background-color: #e8e8e8;
		padding: 0.3125rem;
		text-align: center;
		color: #1482F0;
		cursor: pointer;
	}
</style>
